import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { StringUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, ConsultationsActions, PracticeActions, ScheduleActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar, AppointmentsList } from  '../../components'

class AppointmentsListScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      is_management: false,
      is_provider: false,
      display_appointments: [],
      current_filter: 'UPCOMING',
    }
  }

  componentDidMount() {
    let token         = this.props.user    && this.props.user.auth.token          ? this.props.user.auth.token          : '';
    let current_role  = this.props.context && this.props.context.selectedRole     ? this.props.context.selectedRole     : '';
    let pracitce_id   = this.props.context && this.props.context.selectedPractice ? this.props.context.selectedPractice : '';

    let is_management = current_role === 'practice_owner' || current_role === 'practice_manager' || current_role === 'admin' || current_role === 'tech' ? true : false;
    let is_provider   = current_role === 'vet' || current_role === 'behaviorist'

    this.props.scheduleActions.getPracticeAppointments(token, pracitce_id, true);
    this.setState({ ...this.state, is_provider: is_provider, is_management: is_management });
  }

  renderListSection = () => {

    let apt_display_array_ids = this.getAppointmentIdsToDisplay();

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">

        <AppointmentsList
          appointments={this.props.schedule.appointmentsDict}
          appointmentsIds={apt_display_array_ids}
          consultations={this.props.consultations.allConsultations}
          users={this.props.user.users}
          consultationsActions={this.props.consultationsActions}
          hideTitle={true}
          displayFilters={true}
          currentFilter={this.state.current_filter}
          onFilterChange={ (new_filter) => { this.setState({ ...this.state, current_filter: new_filter }) }}
        />

      </div>
    </div>
  }

  render() {

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="All Appointments" />
        { this.renderListSection() }
      </div>
    );
  }

  getAppointmentIdsToDisplay = () => {
    let array   = [];
    let filter  = this.state.current_filter || 'UPCOMING';
    let user_id = this.props.user.auth && this.props.user.auth.user_id ? this.props.user.auth.user_id : '';
    let appointments  = this.props.schedule && this.props.schedule.practiceAllAppointmentIds ? this.props.schedule.practiceAllAppointmentIds : [];
    let apt_dict      = this.props.schedule && this.props.schedule.appointmentsDict ? this.props.schedule.appointmentsDict : {};
    let provider_only = this.state.is_provider;

    appointments.forEach((appointment_id) => {
      let appointment = apt_dict[appointment_id] || null;
      if (appointment && appointment.status === filter) {
        let participants = appointment.data && appointment.data.participants ? appointment.data.participants : [];
        let user_is_participant = participants.indexOf(user_id) !== -1 ? true : false;
        if (!provider_only || (provider_only && user_is_participant)) {
          array.push(appointment._id);
        }
      }
    });

    return array;
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    consultations: state.consultations,
    practice: state.practice,
    schedule: state.schedule,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    consultationsActions: bindActionCreators(
     { ...ConsultationsActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    scheduleActions: bindActionCreators(
     { ...ScheduleActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentsListScreen)
